export const ibanDeRegex = new RegExp(/^(DE[0-9]{2})\d{18}$/);